import { render, staticRenderFns } from "./ProjectTermsView.vue?vue&type=template&id=73b499ed&scoped=true&"
import script from "./ProjectTermsView.vue?vue&type=script&lang=js&"
export * from "./ProjectTermsView.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTermsView.vue?vue&type=style&index=0&id=73b499ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b499ed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardTitle,VContainer,VDatePicker,VFlex,VLayout,VMenu,VTextField,VTextarea})
